<template>
  <div>
    <el-tabs v-model="activeName" tab-position="left" class="XJTab">
      <el-tab-pane v-for="(item, index) in XJList" :key="index" :label="item.name" :name="item.name">
        <el-row>
          <div class="contentTitle"
            style="color: #ee7a18; font-size: 36px; padding: 20px 100px">
            {{that.$root.language == 1?item.textName:item.textName_en}}
          </div>
          <div class="content" style="padding: 20px 100px">
            <div class="top" style="padding-bottom: 20px; font-size: 24px">
              {{that.$root.language == 1?'1、产品概述':'1. GENERAL DESCRIPTION'}}
            </div>
            <div v-show="item.description1" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description1:item.description1_en}}
            </div>
            <div v-show="item.description2" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description2:item.description2_en}}
            </div>
            <div v-show="item.description3" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description3:item.description3_en}}
            </div>
            <div v-show="item.description4" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description4:item.description4_en}}
            </div>
            <div class="center" style="padding: 20px 0; font-size: 24px">
              {{that.$root.language == 1?'2、产品指标':'2、PRODUCT INDEX'}}
            </div>
            <img v-if="that.$root.language == 1" v-show="item.img1" :src="item.img1"
                 style="width: 100%" />
            <img v-if="that.$root.language != 1" v-show="item.img1" :src="item.img1_en"
                 style="width: 100%" />
            <div class="bottom" style="padding: 20px 0; font-size: 24px">
              {{that.$root.language == 1?'3、应用性能比较':'3、TECHNICAL DATA'}}
            </div>
            <div v-show="item.compare1" class="compare" style="padding: 10px 0;text-indent: 2em">{{that.$root.language == 1?item.compare1:item.compare1_en}}</div>
            <div v-show="item.compare2" class="compare" style="padding: 10px 0;text-indent: 4em">{{that.$root.language == 1?item.compare2:item.compare2_en}}</div>
            <div v-show="item.compare3" class="compare" style="padding: 10px 0;text-indent: 4em">{{that.$root.language == 1?item.compare3:item.compare3_en}}</div>
            <div v-show="item.compare4" class="compare" style="padding: 10px 0;text-indent: 4em">{{that.$root.language == 1?item.compare4:item.compare4_en}}</div>
            <div v-show="item.compare5" class="compare" style="padding: 10px 0;text-indent: 4em">{{that.$root.language == 1?item.compare5:item.compare5_en}}</div>
            <div v-show="item.compare6" class="compare" style="padding: 10px 0;text-indent: 4em">{{that.$root.language == 1?item.compare6:item.compare6_en}}</div>
            <img v-if="that.$root.language == 1" v-show="item.img2" :src="item.img2" style="width: 100%" />
            <img v-if="that.$root.language != 1" v-show="item.img2" :src="item.img2_en" style="width: 100%" />
            <div class="remark">
              <div v-show="item.remark1" class="remarkFir" style="padding: 10px 0"> {{that.$root.language == 1?item.remark1:item.remark1_en}}</div>
              <div v-show="item.remark2" class="remarkSec" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark2:item.remark2_en}}</div>
              <div v-show="item.remark3" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark3:item.remark3_en}}</div>
              <div v-show="item.remark4" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark4:item.remark4_en}}</div>
              <div v-show="item.remark5" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark5:item.remark5_en}}</div>
              <div v-show="item.remark6" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark6:item.remark6_en}}</div>
              <div v-show="item.remark7" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark7:item.remark7_en}}</div>
            </div>
            <div class="fourth" style="padding: 20px 0; font-size: 24px">
              {{that.$root.language == 1?'4、产品供应':'4、PRODUCT SUPPLY'}}
            </div>
            <div v-show="item.pack1" style="padding: 10px 0">{{that.$root.language == 1?item.pack1:item.pack1_en}}</div>
            <div v-show="item.pack2" style="padding: 10px 0">{{that.$root.language == 1?item.pack2:item.pack2_en}}</div>
            <div v-show="item.pack3" style="padding: 10px 0">{{that.$root.language == 1?item.pack3:item.pack3_en}}</div>
            <div v-show="item.pack4" style="padding: 10px 0">{{that.$root.language == 1?item.pack4:item.pack4_en}}</div>
          </div>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
        that:this,
        activeName: 'ALC068',
        XJList: [
        {
          name: "ALC068",
          textName: '安仑ALC068特种炭黑',
          textName_en: 'ALC068 SPECIALTY CARBON BLACKS',
          description1: 'ALC068炭黑是安仑化工推出的ALC系列导电产品成员之一，主要用于中低压电缆的导体屏蔽料和绝缘屏蔽料，以及需要静电释放的橡胶、塑料制品。',
          description1_en: 'ALC068 conductive carbon black is one of ALC-family of conductive product launched by Anlun Chemical. It is mainly used in conductor shield and insulation shield for medium and low voltage power cables, performance.',
          description2: '',
          description3: '',
          description4: '',
          compare1: 'ALC068具有以下优异性能：',
          compare1_en: 'ALC068 carbon black has the following application characteristics:',
          compare2: '相较于常规N550炭黑，相同添加量下有更低的体积电阻率；',
          compare2_en: 'Low volume resistivity under the same carbon black loading as regular N550;',
          compare3: '极低的杂质含量和优异的分散性，保证屏蔽料挤出表面光滑；',
          compare3_en: 'Low impurity and good dispersion to ensure smooth surface of extrudate of cable shield;',
          compare4: '良好的挤出加工性能。',
          compare4_en: 'Good extrusion property.',
          compare5: '',
          compare6: '',
          remark1: '',
          remark2: '',
          remark4: '',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：20kg PE袋/纸袋；500kg FIBC; 1,000kg FIBC',
          pack2_en: 'Packaging: 20kg PE; 500kg FIBC; 1,000kg FIBC',
          pack3: '形态：粉体',
          pack3_en: 'Product Form: powder',
          pack4: '包装：10kg PE袋/纸袋',
          pack4_en: 'Packaging: 10kg PE/Paper bag',
          img1: require("../../assets/img/shuzhi/ALC068-1.jpg"),
          img1_en: require("../../assets/img/shuzhi/ALC068-1-EN.jpg"),
          img2: '',
        },
        {
          name: "ALC072",
          textName: '安仑ALC072特种炭黑',
          textName_en: '安仑ALC072特种炭黑',
          description1: 'ALC072炭黑是安仑化工推出的ALC系列导电产品成员之一，主要用于中高压电缆的导体屏蔽料和绝缘屏蔽料，以及不同电性能要求的橡胶、塑料制品。添加不同填充量，成品可分别获得导\n' +
                        '电、抗静电和静电耗散等不同的电性能。相比于ALC068，ALC072产品具有更好的导电性能，在获\n' +
                        '得相同导电性能时，可减少10-20%的炭黑填充量。',
          description1_en: 'ALC072 conductive carbon black is one of ALC-family of conductive product launched by Anlun \n' +
                        'Chemical. It is mainly used in conductor shield and insulation shield for medium and high voltage \n' +
                        'power cables, as well as rubber and plastic products with a wide range of conductive applications.',
          description2: ' ',
          description2_en: 'By compounding ALC072 with different loading PHR, the electrical property of the final product from \n' +
                        'insulative to conductive, anti-static, or dissipative will be achieved. In comparison to ALC068, to \n' +
                        'achieve the equal electrical performance, ALC072 loading can be reduced by 10-20% due to its \n' +
                        'unique properties.',
          description3: '',
          description4: '',
          compare1: '与ALC072具有以下优异性能：',
          compare1_en: 'ALC072 carbon black has the following important features:：',
          compare2: '相比其他ALC家族产品，ALC072能够以较少的添加量获得相同的导电性能；',
          compare2_en: 'Compared to ALC068, ALC072 provides equal electrical property with less carbon black loading;',
          compare3: '极低的杂质和良好的分散性，保证挤出表面光滑；',
          compare3_en: 'Low Grit level and easy to disperse to ensure smooth surface of shielding material extrusion;',
          compare4: '接近N330的补强性能，保证制品的物理机械性能和使用寿命。',
          compare4_en: 'Comparable to N330 in reinforcement guarantee a long service life of downstream products in terms of mechanical properties.',
          compare5: '',
          compare6: '',
          remark1:'',
          remark2: '',
          remark4: '',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：20kg PE袋/纸袋；500kg FIBC; 1,000kg FIBC',
          pack2_en: 'Packaging: 20kg PE; 500kg FIBC; 1,000kg FIBC',
          pack3: '形态：粉体',
          pack3_en: 'Product Form: powder',
          pack4: '包装：10kg PE袋/纸袋',
          pack4_en: 'Packaging: 10kg PE/Paper bag',
          img1: require("../../assets/img/shuzhi/ALC072-1.jpg"),
          img1_en: require("../../assets/img/shuzhi/ALC072-1-EN.jpg"),
          img2: '',
        },{
          name: "ALC200",
          textName: '安仑ALC200特种炭黑',
          textName_en: 'ALC200 SPECIALTY CARBON BLACKS',
          description1: 'ALC200炭黑是安仑化工推出的ALC系列导电产品成员之一，主要用于中低压电缆的绝缘屏蔽层，具有良好的剥离性能。ALC200的洁净度和导电性也可用于中低压电缆的导体屏蔽层。',
          description1_en: 'ALC200 conductive carbon black is one of ALC-family of conductive product launched by Anlun \n' +
                        'Chemical. It is mainly used in insulation shield for medium and low voltage power cables, where \n' +
                        'strippability is required or mandated. It’s excellent cleanliness and conductivity performance allows \n' +
                        'to use in conductor shields as well.',
          description2: '',
          description3: '',
          description4: '',
          compare1: 'ALC200具有以下优异性能：',
          compare1_en: 'ALC200 carbon black has the following important features：',
          compare2: '相较于其他ALC家族产品，ALC200具有良好的可剥离性；',
          compare2_en: 'Good conductivity to protect against premature cable failure;',
          compare3: '极低的杂质和优异的分散性，保证屏蔽料挤出表面光滑；',
          compare3_en: 'Enable low strip force in strippable semicon shields;',
          compare4: '良好的电性能，确保电缆的使用寿命；',
          compare4_en: 'Low impurity and good dispersion to ensure smooth surface of extrudate of cable shield.',
          compare5: '',
          compare6: '',
          remark1:'',
          remark2: '',
          remark4: '',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：20kg PE袋/纸袋；500kg FIBC; 1,000kg FIBC',
          pack2_en: 'Packaging: 20kg PE; 500kg FIBC; 1,000kg FIBC',
          pack3: '形态：粉体',
          pack3_en: 'Product Form: powder',
          pack4: '包装：10kg PE袋/纸袋',
          pack4_en: 'Packaging: 10kg PE/Paper bag',
          img1: require("../../assets/img/shuzhi/ALC200-1.jpg"),
          img1_en: require("../../assets/img/shuzhi/ALC200-1-EN.jpg"),
          img2: '',
        },{
          name: "ALC500",
          textName: '安仑ALC500特种炭黑',
          textName_en: 'ALC500 SPECIALTY CARBON BLACKS',
          description1: 'ALC500炭黑是安仑化工推出的ALC系列导电产品的旗舰，具有优异的导电性能、超高的洁净度及易加工特性，主要用于中高压电缆的屏蔽料。',
          description1_en: 'ALC500 conductive carbon black is the flagship product of ALC-family of conductive product \n' +
                        'launched by Anlun Chemical. It is mainly used in conductor shield and insulation shield for medium \n' +
                        'and high voltage power cables in terms of excellent conductivity, super cleanliness and easy \n' +
                        'processibility.',
          description2: '',
          description3: '',
          description4: '',
          compare1: 'ALC500具有以下优异性能：',
          compare1_en: 'ALC500 carbon black has the following several important features:',
          compare2: '良好的电性能，确保电缆的使用寿命；',
          compare2_en: 'Good conductivity to protect against premature cable failure;',
          compare3: '极低的硫含量和金属含量；',
          compare3_en: 'Extremely low sulfur content and impurity content;',
          compare4: '极低的杂质含量和优异的分散性，保证挤出屏蔽料表面光滑；',
          compare4_en: 'Low impurity and good dispersion ensure smooth surface of extrudate of cable shield;',
          compare5: '优异的挤出加工性能，延长滤网寿命。',
          compare5_en: 'Excellent processability to prolong long filter screen life.',
          compare6: '',
          remark1:'',
          remark2: '',
          remark4: '',
          pack1: '形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：20kg PE袋/纸袋；500kg FIBC；1,000kg FIBC',
          pack2_en: 'Packaging: 20kg PE; 500kg FIBC; 1,000kg FIBC',
          pack3: '形态：粉体',
          pack3_en: 'Product Form: powder',
          pack4: '包装：7.5kg/10kg PE袋/纸袋',
          pack4_en: 'Packaging: 10kg PE/Paper bag',
          img1: require("../../assets/img/shuzhi/ALC500-1.jpg"),
          img1_en: require("../../assets/img/shuzhi/ALC500-1-EN.jpg"),
          img2: '',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
  width: 150px;
}
::v-deep .el-tabs__item.is-active {
  background-color: rgba($color: #000000, $alpha: 0.1);
}
::v-deep .el-tabs__nav{
  background-color: #ffffff !important;
  color: #000000 !important;
}
::v-deep .el-tabs__item.is-active {
  color: #ee7a18 !important;
}
::v-deep .el-tabs__item:hover {
    color: #ee7a18 !important;
    cursor: pointer !important;
}
::v-deep #tab-ALC068 {
  text-align: center;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
}::v-deep #tab-ALC072 {
  text-align: center;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
}::v-deep #tab-ALC200 {
  text-align: center;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
}::v-deep #tab-ALC500 {
  text-align: center;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
}
</style>